import React, { useEffect } from 'react'
import { Card, TextField, CardContent, Button, FormControl, Grid, MenuItem } from '@mui/material';

import { LinearLoading, CustomAutocomplete, CustomLoading } from '../../../../common'

export const FormAssignment = ({ useFetchInit }) => {

    const {
        globalStates,
        Forms,
        FetchData,
        Actions
    } = useFetchInit

    const { modalOpeningMode, loadingSubmitForm } = globalStates

    const { FormScreen } = Forms
    const { formState, onInputChange, onSelectSearchChange } = FormScreen
    
    const { fetchModulos, fetchSecciones } = FetchData
    const { dataModulos, loadingFetchModulos } = fetchModulos
    const { dataSecciones, loadingFetchSecciones } = fetchSecciones

    const {
        onSubmitForm,
        handleClickHideForm
    } = Actions

    useEffect(() => {
        
        fetchSecciones.setParamsToSearch({
            idmodulo: parseInt(formState.idmodulo, 10)
        })
        fetchSecciones.executeFetch()

    }, [formState.idmodulo])

    return (
        <Card style={{zIndex:'1'}}>
            <CardContent>
                <div className='h4 mt-1 mb-1'>
                    {formState.idmovimiento > 0
                        ? 'Informacion de Registro'
                        : 'Crear Registro'}
                </div>
                <div className="border-bottom border-dark"></div>
                {/* {loadingFetchSpecificTransactionCashier && ( <LinearLoading /> )} */}

                <div className="pt-3"></div>
                <p className='text-danger'>* campos obligatorios</p>
                <div className="pt-2"></div>

                <form onSubmit={onSubmitForm}>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <FormControl fullWidth>
                                <label htmlFor="idmodulo">* Modulo</label>
                                {(loadingFetchModulos)&&(<LinearLoading/>)}
                                <CustomAutocomplete 
                                    customId="idmodulo"
                                    customName="idmodulo"
                                    customValue={formState.idmodulo}
                                    customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idmodulo', value: value.value }})}
                                    customPlaceholder='Seleccionar opción'
                                    customOptions={
                                        dataModulos.map(({ idmodulo, nombre }) => ({
                                            value: idmodulo,
                                            name: nombre
                                        }))
                                    }
                                    customDisableClearable={true}
                                    customDisabled={(modalOpeningMode==='READONLY')}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <FormControl fullWidth>
                                <label htmlFor="idseccion">* Seccion</label>
                                {(loadingFetchSecciones)&&(<LinearLoading/>)}
                                <CustomAutocomplete
                                    customId="idseccion"
                                    customName="idseccion"
                                    customValue={formState.idseccion}
                                    customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idseccion', value: value.value }})}
                                    customPlaceholder='Seleccionar opción'
                                    customOptions={
                                        dataSecciones.map(({ idseccion, nombre }) => ({
                                            value: idseccion,
                                            name: nombre
                                        }))
                                    }
                                    customDisableClearable={true}
                                    customDisabled={(modalOpeningMode==='READONLY')}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <div className="pt-4"></div>

                    <div className="pt-4"></div>
                    {(loadingSubmitForm)&&(<CustomLoading/>)}
                    <Grid container>
                        <Grid item>
                            <div className='update ml-auto mr-auto'>
                                <Button
                                    style={{background: "#4b4b4c"}}
                                    variant="contained"
                                    type='submit'
                                    disabled={(modalOpeningMode==='READONLY') || loadingSubmitForm}
                                >
                                    <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                                </Button>
                                &nbsp; &nbsp;
                                <Button
                                    style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                    type='button'
                                    variant="contained"
                                    onClick={handleClickHideForm}
                                    disabled={loadingSubmitForm}
                                >
                                    <i className="fa-regular fa-circle-left"></i> &nbsp; Cancelar
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </form>
            </CardContent>
        </Card>
    )
}
